import React, { useState } from 'react';
import { Form, InputNumber, message, Modal } from 'antd';

import ClientVersionSelect from '@lib/components/client-version-select';
import EnvironmentSelect from '@lib/components/env-select';

import { arenaSegmentService } from '../../../../../services/cstool';

type PropsType = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

const CreateSegmentModal = (props: PropsType) => {
  const { isOpen, setIsOpen } = props;
  const [form] = Form.useForm();
  const [environment, setEnvironment] = useState<string>();
  const [blueprintVersion, setBlueprintVersion] = useState<string>();

  const closeModal = () => {
    form.resetFields();
    setEnvironment(undefined);
    setBlueprintVersion(undefined);
    setIsOpen(false);
  };

  const handleOk = async () => {
    const formValues = form.getFieldsValue();

    if (!formValues.numberOfPlayers || !formValues.rank || !blueprintVersion) {
      message.error('Please fill out all fields completely!!!');
      return;
    }

    await arenaSegmentService.createArenaSegment({
      ...formValues,
      blueprintVersion,
      environment,
    });
    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  return (
    <Modal title="Create Segment" visible={isOpen} onOk={handleOk} onCancel={handleCancel}>
      <Form form={form} labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}>
        <Form.Item name="environment" label="Environment" required>
          <EnvironmentSelect onChange={setEnvironment} />
        </Form.Item>
        <Form.Item name="blueprintVersion" label="Client Version" required>
          <ClientVersionSelect
            environment={environment}
            disabled={!environment}
            onChange={setBlueprintVersion}
          />
        </Form.Item>
        <Form.Item name="numberOfPlayers" label="Number of Players" required>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="rank" label="Rank" required>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateSegmentModal;
